/*jshint esversion: 6 */
export function sortAllPageObjects(pageObjects){
    let sortedPages = pageObjects.map(pageObject =>{
        return paragraphProxy(pageObject);
    });
    return sortedPages;
}

export function paragraphProxy(pageObject){
    //console.log('PAGEDISPLAYER paragraphProxy() pageObject', pageObject);
    // console.log('PAGEDISPLAYER paragraphProxy() pageObject type=', typeof(pageObject));
    // console.log('pageObject.isAvaleht', pageObject.isAvaleht);
    // console.log('pageObject.order', pageObject.order);
    // console.log('pageObject.page_type', pageObject.page_type);
    // console.log('pageObject.paragraphObjects', pageObject.paragraphObjects);
    // console.log('pageObject[paragraphObjects]', pageObject['paragraphObjects']);
    if(pageObject.paragraphObjects){
        let paragraphObjects = pageObject.paragraphObjects;
        console.log('PAGEDISPLAYER paragraphProxy() pageObject.paragraphObjects', paragraphObjects);
        console.log('PAGEDISPLAYER paragraphProxy() pageObject.paragraphObjects type=', typeof(paragraphObjects));
        if(paragraphObjects.length){
        console.log('PAGEDISPLAYER paragraphProxy() pageObject.paragraphObjects.length = ', paragraphObjects.length);
        let paragraphObjects_ = paragraphObjects.slice();
        pageObject.paragraphObjects = sortParagraphObjects(pageObject._id, paragraphObjects_);
        //sortparagrObjects
        pageObject.paragraphObjects.map(p =>{
            let mObjs = p.manusObjects.slice();
            let mOrders = p.manus_orders.slice();
            p.manusObjects = sortManusObjects(mOrders, mObjs);
        });
        }
    }
    //let templateId = pageObject.paragraphObjects.display_type;
}


export function sortManusObjects(manusOrders, manusObjects){
    if(manusObjects){
        if(manusObjects.length){
            if(manusObjects.length == 1){
               return manusObjects;
            }
        }
    }
    let sortedManusArray=[];
    let sortedManusNumbersArray=[];

    manusOrders.map(orderPair => {
        let orderPairArray = orderPair.split(':');
        if(orderPairArray.length === 2){
            let orderNr = parseInt(orderPairArray[1], 10);
            sortedManusNumbersArray.push({order:orderNr , id:orderPairArray[0]});
        }
    });
    sortedManusNumbersArray.sort(function (a, b) {
        return a.order - b.order;
    });
    console.log('sortedManusArray', sortedManusArray);
    sortedManusNumbersArray.forEach(number => {
        let orderedmanusArr = manusObjects.filter(mo => mo._id === number.id);
        if(orderedmanusArr){
            if(orderedmanusArr.length){
            sortedManusArray.push(orderedmanusArr[0]);
            }
        }
    });
    return sortedManusArray;
}

export function sortParagraphObjects(pageId, paragraphObjects){
    let sortedParagArray=[];
    let sortedNumbersArray=[];
    paragraphObjects.map(p => {
        /* orders :["5abcd5a477fce92adc405485:1", "5abca81857929f125e3ef31a:1"] */
        let orders = p.orders.filter(o => o.includes(pageId));
        orders.map(orderPair => {
        let orderPairArray = orderPair.split(':');
        if(orderPairArray.length === 2){
            let orderNr = parseInt(orderPairArray[1], 10);
            sortedNumbersArray.push({order:orderNr , par:p});
        }
        });//orders.map
    });//paragraphObjects.map
    sortedNumbersArray.sort(function (a, b) {
        return a.order - b.order;
    });
    sortedNumbersArray.forEach(nrP => {
        sortedParagArray[nrP.order] = nrP.par;
    });
    //console.log('sortedParagArray', sortedParagArray);
    return sortedParagArray;
}



// WEBPACK FOOTER //
// ./src/utils/sortObjects.js